export const dashboard = {
  hello: 'Bun venit',
  headline: 'Folosește navigarea laterală pentru a accesa secțiunile aplicației'
}
